import gql from "graphql-tag";

export const projectQuery = gql`
  query Projects($slug: String!) {
    projects(filters:{slug: {eq: $slug}}) {
      data {
      id
        attributes {
          title
          headline
          content
          darkmode
          video
          type {
            data {
              id
            }
          }
          industry {
            data {
              attributes {
                title
              }
            }
          }
          categories {
            data {
              attributes {
                title
              }
            }
          }
          status {
            data {
              attributes {
                title
              }
            }
          }
          image {
            data {
              attributes {
                width
                height
                caption
                mime
                url
                hash
                ext
              }
            }
          }
          hero {
            data {
              attributes {
                width
                height
                caption
                mime
                url
                hash
                ext
              }
            }
          }
          modules {
            ... on ComponentModuleText {
              text
              textplacement: placement
            }
            ... on ComponentModuleColors {
              invert
            }
            ... on ComponentModuleEmbed {
              code
            }
            ... on ComponentModuleVideo {
              link
              autoplay
              cover {
                data {
                  attributes {
                    width
                    height
                    caption
                    mime
                    url
                    hash
                    ext
                  }
                }
              }
            }
            ... on ComponentModuleSlideshow {
              delay
              arrows
              effect
              speed
              autoplay
              highresolution
              slides(pagination: { limit: 100 }) {
                title
                text
                textcolor
                buttontextcolor
                mediaAlignment
                textAlignment
                fit
                mute
                media {
                  data {
                    attributes {
                      width
                      height
                      caption
                      mime
                      url
                      hash
                      ext
                    }
                  }
                }
                buttons {
                  title
                  project_relation: project {
                    data {
                      attributes {
                        slug
                      }
                    }
                  }
                  page_relation: page {
                    data {
                      attributes {
                        slug
                      }
                    }
                  }
                }
              }
            }
            ... on ComponentModuleImages {
              imageplacement: placement
              type
              images {
                data {
                  attributes {
                    width
                    height
                    caption
                    mime
                    url
                    hash
                    ext
                  }
                }
              }
            }
            ... on ComponentModuleProjects {
              grid
              projects(sort: "date:DESC") {
                data {
                  attributes {
                    slug
                    title
                    headline
                    image {
                      data {
                        attributes {
                          width
                          height
                          caption
                          mime
                          url
                          hash
                          ext
                        }
                      }
                    }
                    video
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`